<template>
  <div class="product-links">
    <v-row class="ma-n2">
      <v-col class="pa-2" v-if="samplesUrl">
        <ng-button
          block
          class="elevation-0"
          :href="samplesUrl"
          target="_blank"
          icon-name="mdi-eye-outline"
          icon-position="left"
          >{{ $t('product.samples') }}</ng-button
        >
      </v-col>
      <v-col class="pa-2" v-if="dataStructureUrl">
        <ng-button
          block
          class="elevation-0"
          :href="dataStructureUrl"
          target="_blank"
          icon-name="mdi-layers-outline"
          icon-position="left"
          >{{ $t('product.structure') }}</ng-button
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    samplesUrl: {
      type: [Object, String],
    },
    dataStructureUrl: {
      type: String,
    },
  },
  computed: {
    ...mapState('product', ['id']),
  },
};
</script>

<style lang="scss" scoped></style>
